import { S as StackingMode, V as VisibilityMode, i as VizOrientation, G as GraphGradientMode } from '../../../../../index-DuYVZf5J.js';

"use strict";
const pluginVersion = "13.0.0-pre";
const defaultOptions = {
  barRadius: 0,
  barWidth: 0.97,
  fullHighlight: false,
  groupWidth: 0.7,
  orientation: VizOrientation.Auto,
  showValue: VisibilityMode.Auto,
  stacking: StackingMode.None,
  xTickLabelRotation: 0,
  xTickLabelSpacing: 0
};
const defaultFieldConfig = {
  fillOpacity: 80,
  gradientMode: GraphGradientMode.None,
  lineWidth: 1
};

export { defaultFieldConfig, defaultOptions, pluginVersion };
